/**
 * /me/leaves/calendar — Session 3d PR 5.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyLeaveCalendarPage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-leave-calendar", employeeId],
    queryFn: () => session3dApi.listMyLeaveCalendar(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.leave-calendar.title", "My Leave Calendar")}
        subtitle={t("me.leave-calendar.subtitle", "Visual month grid of your approved + pending leaves + holidays.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.leave-calendar.title", "My Leave Calendar"),
          window_label: t("me.leave-calendar.window", "next 90 days"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.leave-calendar.ask_khidmat", "When are the upcoming public holidays I can combine with leave?")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.leave-calendar.detail_note",
                "Calendar visualization: approved leaves (brand-blue dots) · pending requests (amber) · public holidays (emerald) · team overlap (gray · manager view only).",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
